(function(){
  if(window.LanseCart) return;

  function openCartDrawer(){
    var drawer = document.getElementById('cart-drawer');
    if(drawer && typeof drawer.open === 'function'){ drawer.open(); return true; }
    return false;
  }

  // Rafraichit le contenu du tiroir panier via la Section Rendering API de Shopify.
  // IMPORTANT : la section 'cart-drawer-section' est rendue avec render_wrapper:false
  // (voir sections/cart-drawer-section.liquid), donc la reponse NE contient PAS le
  // <div id="shopify-section-cart-drawer-section"> qui existe deja sur la page
  // (rendu par layout/theme.liquid au chargement initial). Il faut donc remplacer le
  // CONTENU (innerHTML) de ce wrapper existant, jamais le wrapper lui-meme :
  // le remplacer entierement supprimerait le <theme-drawer id="cart-drawer"> et
  // casserait le panier pour le reste de la session.
  function refreshCartDrawerSection(){
    return fetch('/?sections=cart-drawer-section')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var html = data && data['cart-drawer-section'];
        var wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if(html && wrapper){
          wrapper.innerHTML = html;
          return true;
        }
        return false;
      })
      .catch(function(err){
        console.warn('[LanseCart] refresh drawer failed', err);
        return false;
      });
  }

  function updateCartBubbles(itemCount){
    document.querySelectorAll('.la-cart-icon-el').forEach(function(el){
      var countEl = el.querySelector('.cart-bubble__text-count');
      var bubbleEl = el.querySelector('.cart-bubble');
      if(countEl){
        countEl.textContent = itemCount > 0 ? itemCount : '';
        countEl.classList.toggle('hidden', itemCount === 0);
      }
      if(bubbleEl){ bubbleEl.classList.toggle('visually-hidden', itemCount === 0); }
    });
  }

  function showToast(){
    var toast = document.getElementById('laToast');
    if(!toast) return;
    toast.classList.add('la-toast--show');
    clearTimeout(window.__laToastTimer);
    window.__laToastTimer = setTimeout(function(){
      toast.classList.remove('la-toast--show');
    }, 2600);
  }

  window.LanseCart = {
    add: function(variantId, quantity){
      quantity = quantity || 1;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
      .then(function(res){
        if(!res.ok){ return res.json().then(function(err){ throw err; }); }
        return res.json();
      })
      .then(function(){
        return fetch('/cart.js').then(function(r){ return r.json(); });
      })
      .then(function(cart){
        updateCartBubbles(cart.item_count);
        return refreshCartDrawerSection().then(function(refreshed){
          var opened = refreshed && openCartDrawer();
          if(!opened){
            // Filet de securite : si le tiroir ne peut pas s'ouvrir pour une
            // raison quelconque, on envoie quand meme le client sur /cart
            // pour qu'il puisse finaliser sa commande sans blocage.
            window.location.href = '/cart';
            return cart;
          }
          showToast();
          return cart;
        });
      })
      .catch(function(err){
        console.error('[LanseCart] add failed', err);
        var message = (err && (err.description || err.message)) || "Impossible d'ajouter cet article au panier.";
        alert(message);
        throw err;
      });
    }
  };

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-lanse-add-to-cart]');
    if(!btn) return;
    e.preventDefault();
    if(btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if(!variantId){ console.warn('[LanseCart] bouton sans data-variant-id'); return; }
    var qty = parseInt(btn.getAttribute('data-quantity') || '1', 10);
    btn.disabled = true;
    btn.dataset.laLoading = '1';
    window.LanseCart.add(variantId, qty).then(function(){
      btn.disabled = false;
      delete btn.dataset.laLoading;
    }).catch(function(){
      btn.disabled = false;
      delete btn.dataset.laLoading;
    });
  });
})();
